import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const NAV = [
  { id: "about", label: "About" },
  { id: "skills", label: "Skills" },
  { id: "experience", label: "Experience" },
  { id: "projects", label: "Work" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-black/70 backdrop-blur-xl border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-4 flex items-center justify-between">
        <button
          data-testid="header-logo"
          onClick={() => go("hero")}
          className="font-display font-black text-lg tracking-tighter hover:text-white/80 transition-colors border border-white/20 rounded-full px-4 py-1 hover:border-white/50"
        >
          SATYAM<span className="text-white/30">.</span>
        </button>

        <nav className="hidden md:flex items-center gap-8">
          {NAV.map((n) => (
            <button
              key={n.id}
              data-testid={`nav-${n.id}`}
              onClick={() => go(n.id)}
              className="label-eyebrow hover:text-white transition-colors"
            >
              {n.label}
            </button>
          ))}
          <button
            data-testid="nav-cta"
            onClick={() => go("contact")}
            className="bg-white text-black px-5 py-2 text-xs font-mono uppercase tracking-[0.18em] hover:bg-neutral-200 transition-colors"
          >
            Hire me
          </button>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden p-2 border border-white/15"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden border-t border-white/10 bg-black/95 backdrop-blur-xl"
        >
          <div className="max-w-7xl mx-auto px-6 py-4 flex flex-col gap-1">
            {NAV.map((n) => (
              <button
                key={n.id}
                data-testid={`mobile-nav-${n.id}`}
                onClick={() => go(n.id)}
                className="text-left py-3 label-eyebrow border-b border-white/5"
              >
                {n.label}
              </button>
            ))}
            <button
              data-testid="mobile-nav-cta"
              onClick={() => go("contact")}
              className="mt-3 bg-white text-black py-3 text-xs font-mono uppercase tracking-[0.18em]"
            >
              Hire me
            </button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
